import isCycleSafe from './isCycleSafe'

function removeCyclesTransform(
  input: any,
  { refs, path }: { refs: Map<string, Object>; path: string } = {
    refs: new Map(),
    path: ''
  }
): any {
  if (isCycleSafe(input)) {
    return input
  }

  if (refs.has(input)) {
    return `<Reference to ${refs.get(input) || '/'}>`
  }
  refs.set(input, path)

  return Object.fromEntries(
    Object.entries(input).map(([key, value]) => [
      key,
      removeCyclesTransform(value, { refs, path: `${path}/${key}` })
    ])
  )
}

function removeCycles(input: any): any {
  return removeCyclesTransform(input)
}

export default removeCycles
